import { useQuery } from '@tanstack/react-query';

import { useAuthContext } from '@cognite/e2e-auth';

import { QueryKeys } from '../../../../utils/queryKeys';

export const useSpaceQuery = (space: string[] | string, enabled: boolean) => {
  const { client } = useAuthContext();

  return useQuery({
    queryKey: [QueryKeys.FDM_SPACE_BYID, space],
    queryFn: async () => {
      return client.spaces
        .retrieve(typeof space === 'string' ? [space] : space)
        .then((res) => res.items);
    },
    meta: { error: { captureError: true } },
    enabled: enabled && space !== '',
    retry: false,
  });
};
